import { createContext, useCallback, useEffect, useState } from "react";
import { useAuthContext } from "../../auth/useAuthContext";
import useClientProgram from "../../hooks/api/useClientProgram";
import { getTimetoUserLocalUtcFormat } from "../../utils/formatTime";

export const PlatformContext = createContext(null);

export const PlatformProvider = ({children}) => {
    
    const {user, isInitialized, isAuthenticated} = useAuthContext()
    const [program, setProgram] = useState(null)
    const [programs, setPrograms] = useState([])

    const clientProgramManager = useClientProgram()

    const initialize = useCallback(async() => {
        try {
            const _request = await clientProgramManager.actions.onGetAll()
            console.log(_request.data)
            setPrograms(_request.data)

            let _program = null
            _program= _request.data.find(el => {
                const _startdate = getTimetoUserLocalUtcFormat(el?.start_date)
                const _enddate = getTimetoUserLocalUtcFormat(el?.end_date)
                const today = (new Date()).toISOString()
                return today >= _startdate && today <= _enddate
            })
            if(!_program && _request.data.length > 0){
                _program = _request.data[0]
            }
            console.log(_program)
            setProgram(_program)

        } catch (error) {
            console.log(error)
        }
    },[])


    useEffect(() => {
        console.log("Inicalizar")
        if(user) initialize()
    },[user])

    return(
        <PlatformContext.Provider
            value={{
                program
            }}
        >
            {children}
        </PlatformContext.Provider>
    )

}